import { z } from 'zod';

const SLUG = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const loginSchema = z.object({
  email: z.email({ error: 'auth:validation.email' }),
  password: z.string().min(1, { error: 'auth:validation.required' }),
  organizationSlug: z
    .string()
    .trim()
    .max(120, { error: 'auth:validation.organizationSlug' })
    .refine((value) => value === '' || SLUG.test(value), {
      error: 'auth:validation.organizationSlug',
    })
    .optional(),
});

export type LoginValues = z.infer<typeof loginSchema>;
